// PermissionManager Widget

module.exports = fox => {
	'use strict';

	fox.registerWidget('PermissionManager', {
		__constructor: function () {
			this.callParent('__constructor', arguments);

			fox.registerTemplateModifier('hasAccess', function (obj, params) {
				const ruleName = params[0];

				return this.hasAccess(ruleName);
			}.bind(this));
		},

		configure: function () {
			this.registerOptions('', {
				handleWom: {
					permissionsUpdate: {
						event: 'inboxSocketEventPermissions:update',
						widget: '@root #socket',
						callback: 'onPermissionsUpdateCallback'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.rules = {};

			this._defineProperty('member', null, {
				get: () => fox.getEnv('member')
			})

			this.callParent('init', arguments);

			this.applyRules(this.getOption('permissions'));

			/* shortcuts rules */
			this.applyRules({
				guestActual: {},
				free: {}
			});
		},

		applyRules: function (rules = {}) {
			var keys = fox.getObjectKeys(rules).sort((a, b) => {
				if (!(a in this.rules)) return 1;

				return this.hasAccess(a) ? -1 : 1;
			});

			keys.map(key => {
				var RuleConstructor = require(`./rules/${key}`)(fox);
				var rule = this.rules[key];

				if (!rule) {
					rule = this.rules[key] = new RuleConstructor(this, rules[key]);
				} else {
					rule.setParams(rules[key]);
				}

				return rule;
			}).map(rule => rule.execute());

			return keys;
		},

		getRuleParam: function (ruleName, ...args) {
			const rule = this.rules[ruleName];

			return rule && rule.getParams.apply(rule, args);
		},

		hasAccess: function (ruleName) {
			const rule = this.rules[ruleName];
			
			return rule && rule.hasAccess();
		},

		onPermissionsUpdateCallback: function (data) {
			return this.updatePermissions(data.answer);
		},

		updatePermissions: function (data) {
			this.dispatchEvent('permissions_update', this.applyRules(data));
		},

		getMemberInfo: function (path) {
			if (fox.isArray(path)) {
				path.unshift(0);
			}

			if (fox.isString(path)) {
				path = [0, path].join('.');
			}

			return this.member &&
				fox.objectGet(fox.toArray(this.member.collection), path || '0') ||
				{};
		}

	}, 'Controller');

};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/permissionManager.es.js